// test379
(379 && 0);
